<template>
    <section class="amar-akbar-anthony poker space-l" loading="lazy">
         <div class="container-fluid">
            <div class="row  no-gutters">
               <div class="col-md-4 col-12">
                  <h1 class="live-patti-header">
                     Worli Matka
                  </h1>
                  <div class="teen-patti-img">
                     <img loading="lazy" src="@/assets/images/worli-matka.webp" alt="worli-matka">
                  </div>
               </div>
               <div class="col-md-8 col-12">
                  <div class="rules">
                     <h2 class="live-patti-header">
                        Pana Total: 
                     </h2>
                     <div class="v-rules">
                        <ul class="rules-cum-list t-card">
                           <li>
                              The Pana Total is expressed as A+B+C=X.
                           </li>
                           <li>
                              If X is less than 9, X is as derived.
                           </li>
                           <li>
                              If X is greater than 9, for example XY, Y is considered Pana Total.
                           </li>
                           <li>
                              Example:
                           </li>
                           <li>
                              170 = 1+7+0 = 8 (8 Is the Pana Total)
                           </li>
                           <li>
                              179 = 1+7+9 = 17(Here, since, 17 is greater than 9 hence 7 is considered Pana Total)
                           </li>
                        </ul>
                     </div>
                     <h2 class="live-patti-header">
                        Odd - Even:
                     </h2>
                     <div class="v-rules">
                        <ul class="rules-cum-list t-card">
                           <li>
                              Odd Pana is considered when, Pana Total is Odd.
                           </li>
                           <li>
                              Even Pana is considered when, Pana Total is Even.
                           </li>
                        </ul>
                     </div>
                     <h2 class="live-patti-header">
                        Hi - Low:
                     </h2>
                     <div class="v-rules">
                        <ul class="rules-cum-list t-card">
                           <li>
                              Hi Pana is considered when, Pana Total is 6, 7, 8, 9 or 0.
                           </li>
                           <li>
                              Low Pana is considered when, Pana Total is 1, 2, 3, 4 or 5.
                           </li>
                        </ul>
                     </div>
                     <h2 class="live-patti-header">
                        Single Pana:
                     </h2>
                     <div class="v-rules">
                        <ul class="rules-cum-list t-card">
                           <li>
                              Each Single Pana has 12 combinations, and winner Pana is Pana Total.
                           </li>
                           <li>
                              Single Pana is always in X &lt; Y &lt; Z format and all three numbers of Pana are unique.
                           </li>
                           <li>
                              Rate Paid for Single Pana : 1:140
                           </li>
                        </ul>
                     </div>
                     <h2 class="live-patti-header">
                        Double Pana:
                     </h2>
                     <div class="v-rules">
                        <ul class="rules-cum-list t-card">
                           <li>
                              Each Double Pana has 9 combinations.
                           </li>
                           <li>
                              Double Pana is always in X = Y &lt; Z or X &lt; Y = Z format and pana has a repeat digit.
                           </li>
                           <li>
                              Rate Paid for Double Pana : 1:240
                           </li>
                        </ul>
                     </div>
                     <h2 class="live-patti-header">
                        All Trio Pana:
                     </h2>
                     <div class="v-rules">
                        <ul class="rules-cum-list t-card">
                           <li>
                              All Trio Pana is considered when, all three numbers of Pana are same.
                           </li>
                           <li>
                              Rate Paid for All Trio Pana : 1:700
                           </li>
                        </ul>
                     </div>
                     <h2 class="live-patti-header">
                        SPALL:
                     </h2>
                     <div class="v-rules">
                        <ul class="rules-cum-list t-card">
                           <li>
                              SPALL is considered winner, when any Single Pana is winner.
                           </li>
                           <li>
                              Rate Paid for SPALL : 1:140
                           </li>
                        </ul>
                     </div>
                     <h2 class="live-patti-header">
                        DPALL:
                     </h2>
                     <div class="v-rules">
                        <ul class="rules-cum-list t-card">
                           <li>
                              DPALL is considered winner, when any Double Pana is winner.
                           </li>
                           <li>
                              Rate Paid for DPALL : 1:240
                           </li>
                        </ul>
                     </div>
                     <h2 class="live-patti-header">
                        Common SP:
                     </h2>
                     <div class="v-rules">
                        <ul class="rules-cum-list t-card">
                           <li>
                              Common SP is considered winner, when Common SP Pana exists in Single Pana numbers.
                           </li>
                           <li>
                              Rate Paid for Common SP : 1:140
                           </li>
                        </ul>
                     </div>
                     <h2 class="live-patti-header">
                        Common DP:
                     </h2>
                     <div class="v-rules">
                        <ul class="rules-cum-list t-card">
                           <li>
                              Common DP is considered winner, when Common DP Pana exists in Double Pana numbers.
                           </li>
                           <li>
                              Rate Paid for Common DP : 1:240
                           </li>
                        </ul>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
</template>